/* eslint-disable */
class ScrollDown {

  constructor() {
    this.init();
  }

  init() {

    document.querySelectorAll('.scrolldown').forEach( ( container ) => {

      const el = document.createElement("a");
      el.classList.add('scrolld');
      el.href = container.dataset.scrolldownHref !== '' ? container.dataset.scrolldownHref : '#';
      el.title = container.dataset.scrolldownTitle !== '' ? container.dataset.scrolldownTitle : 'Scroll Down';

      if(container.dataset.scrolldownClasses !== '') {
        el.classList.add(container.dataset.scrolldownClasses);
      }

      el.dataset.scrollTo = '';
      el.innerHTML = '<span class="scrolld__arrow"></span>';

      container.appendChild(el);

    });

  }


}

export default ScrollDown;



// WEBPACK FOOTER //
// ./scripts/classes/scrolldown.js